module.exports = __webpack_public_path__ + "static/media/main-stage-5.e400349c.png";